import { Add as AddIcon } from "@material-ui/icons";
import cloneDeep from "lodash/cloneDeep";
import MaterialTable from "material-table";
import React from "react";
import { useHistory } from "react-router";
import { AddButton, BoxCard, PageLayout } from "ui/componentes";
import { useCollection } from "api/hooks/useCollection";
import { Collections } from "api/model/Collections";
import { Championship } from "api/model/Championship";
import { Season } from "api";

const Championships = () => {
    const history = useHistory();
    const seasonsById =
        useCollection<{ [key: string]: Season }>({
            collection: Collections.SEASONS,
        }) || {};

    const championships =
        useCollection<Championship[]>(
            { collection: Collections.CHAMPIONSHIPS },
            true
        ) || [];

    championships.sort((champ1, champ2) => {
        const season1 = seasonsById[champ1.seasonId];
        const season2 = seasonsById[champ2.seasonId];

        if (season1 && season2) {
            if (season1.startAt < season2.startAt) {
                return 1;
            }
            if (season1.startAt > season2.startAt) {
                return -1;
            }
        }

        return champ1.name < champ2.name ? -1 : 1;
    });

    return (
        <PageLayout
            title="Campeonatos"
            boxCardProps={{ padding: 0 }}
            showInBoxCard={false}
        >
            <MaterialTable
                components={{ Container: BoxCard }}
                columns={[
                    { title: "Nome", field: "name" },
                    {
                        title: "Temporada",
                        field: "seaonsId",
                        render: (championship) => {
                            if (!championship.seasonId) return "";

                            const season = seasonsById[championship.seasonId];

                            if (!season) return "";

                            return `${season.name} - ${season.year}`;
                        },
                    },
                ]}
                data={cloneDeep(championships)}
                actions={[
                    {
                        icon: "edit",
                        tooltip: "Editar",
                        onClick: (event, championship) =>
                            history.push(`/championship/${championship["id"]}`),
                    },
                ]}
                options={{
                    paging: false,
                    toolbar: false,
                }}
            />
            <AddButton onClick={() => history.push("/championship")}>
                <AddIcon />
            </AddButton>
        </PageLayout>
    );
};

export { Championships };
export default Championships;
